<!--
 * @Author: your name
 * @Date: 2020-11-17 16:08:15
 * @LastEditTime: 2020-12-16 16:33:49
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \openplat-web\src\gtn\views\frontViews\product\serviceProduct.vue
-->
<template>
  <div class="serviceProduct">
    <market-bar></market-bar>
    <div class="main-contian">
      <request-bar></request-bar>
      <product-list></product-list>
    </div>
  </div>
</template>
<script>
import MarketBar from '@/views/frontViews/components/marketBar'
import RequestBar from '@/views/frontViews/product/requestBar'
import ProductList from '@/views/frontViews/product/productList'
export default {
  name: 'serviceProduct',
  data() {
    return {}
  },

  components: { MarketBar, RequestBar, ProductList },

  computed: {},

  methods: {},
  mounted() {
    if (this.$store.state.product.request.length > 0) {
      this.$store.commit('SET_REQUEST', [])
    } else if (this.$store.state.product.searKeyWord) {
      this.$store.commit('SET_SEARCH', '')
    }
  },
}
</script>
<style lang="scss" scoped>
.serviceProduct {
  // background-image: linear-gradient(
  //   180deg,
  //   #eff8ff 0%,
  //   #f4f9ff 212px,
  //   #ffffff 295px
  // );
  .com-nav {
    height: 50px;
    background: url('../../../assets/service/bg.png') no-repeat 0 0;
    background-size: 100% 50px;
  }
  .search-bar {
    height: 118px;
    background: #eff8ff;
  }
  .main-contian {
    width: 1200px;
    margin: auto;
    overflow: hidden;
    font-size: 14px;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/product/serviceProduct.vue